/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, RIKEN){
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';

	// =======================================================
	// JSON取得 ==============================================
	const getJSONrecipeData = (_key) => {
		return $.getJSON(`/ajax/recipe/${_key}.json`);
	}
	const getJSONproductsData = (_key) => {
		return $.getJSON(`/ajax/products/${_key}.json`);
	}

	// =======================================================
	// 共通 ==============================================
	// 動的に書き出す®をsubで囲う
	const addSub = (_txt) => {
		if(_txt.indexOf('®') !== -1 || _txt.indexOf('🄬') !== -1 || _txt.indexOf('&reg;') !== -1) {
			let newTxt = _txt.replace(/®|🄬|&reg;/g, '<sub>&reg;</sub>');
			return newTxt;
		} else {
			return _txt;
		}
	}
	
	// =======================================================
	// <おいしさの提案> 詳細
	const recipeDetailSlider = () => {
		const setSlide = () => {
			const thisSlider = $('.js-recipeSlider');
			thisSlider.each(function() {
				const ele = $(this);
				const thisSliderDots = ele.next('.mod-slider-dots');

				ele.slick({
					infinite: true,
					speed: 1000,
					autoplaySpeed: 4000,
					autoplay: true,
					slidesToShow: 4,
					arrows: false,
					dots: true,
					appendDots: thisSliderDots,
					responsive: [
						{
							breakpoint: 1024,
							settings: {
								slidesToShow: 2,
							}
						},{
							breakpoint: 768,
							settings: {
								slidesToShow: 1,
							}
						}
					]
				});
				// 再生ボタン
				thisSliderDots.find('button.__play').on('click', () => {
					thisSliderDots.toggleClass(a);
					ele.slick('slickPlay');
				});
				// 停止ボタン
				thisSliderDots.find('button.__pause').on('click', () => {
					thisSliderDots.toggleClass(a);
					ele.slick('slickPause');
				});
			});
		}


		$('.js-products-output').each((idx,ele) => {
			let recipeId = $(ele).find('.rt_recipe_key').text();

			getJSONrecipeData(recipeId).then((data) => {
				let recipeData = data.rt_bn_recipe_info;

				if(recipeData.length) {
					let mainProducts = recipeData[0].cf_r_products_main; 
					let subProducts = recipeData[0].cf_r_products_sub;
					let mainProductsKey;

					if(mainProducts !== null) {
						mainProductsKey = mainProducts._key;
					} else {
						$(ele).find('.__head').remove();
					}
					
					// メイン商品判定
					getJSONproductsData(mainProductsKey).then((data2) => {
						if(data2.rt_bn_products_list.length) {
							let productsData = data2.rt_bn_products_list[0];
							let _name = productsData.cf_p_name;
							let _img = productsData.cf_p_img;
							let _flag = productsData.cf_p_detail_page_flag;
							let _category = productsData.cf_p_category.cf_pc_code;
							let _series = productsData.cf_p_category.cf_pc_series_code;
							let _status = productsData.cf_p_status;
							let _id = productsData._key;
							let _url = "";
							let _class = '';
							let productsHtml = '';

							if(_flag === 0) {
								_url = '/products/'+ _category +'/'+ _series +'/'+ _id +'.html';
							} else {
								_class = 'is-disable';
							}

							productsHtml = `<a href="${_url}" class="__txt ${_class}">
									<span class="">${addSub(_name)}</span>
								</a>`;

							$(ele).append(productsHtml);
						} else {
							$('.js-recipeSlider.slick-initialized').slick('unslick');
							$(ele).parents('.js-relatedRecipes-item').remove();
							setSlide();
							
							if(!$('.js-relatedRecipes-item.is-visible').length) {
								$('.js-relatedRecipes-wrap').remove();
							}
						}
					});

					// サブ商品判定
					if(subProducts !== null) {
						for(let i = 0; i<subProducts.length; i++) {
							getJSONproductsData(subProducts[i]._key).then((data2) => {
								if(!data2.rt_bn_products_list.length) {
									$('.js-recipeSlider.slick-initialized').slick('unslick');
									$(ele).parents('.js-relatedRecipes-item').remove();
									setSlide();
									if(!$('.js-relatedRecipes-item.is-visible').length) {
										$('.js-relatedRecipes-wrap').remove();
									}
								}
							});
						}
					}
				}
			});
		});

		setSlide();
	};

	// <おいしさの提案詳細ページ>他の記事を読む
	const otherArticles  = () => {
		if($('.js-otherArticles-item').length) {
			// ランダムで2件表示
			let numArr = [];
			for(let i=0; i<$('.js-otherArticles-item').length; i++) {
				numArr.push(i);
			}

			let randArr = [];
			let rand;
			for(var i=0,len=numArr.length;i<2;i++,len--){
				rand = Math.floor( Math.random() * len);
				randArr.push(numArr.splice(rand,1)[0]);
			}

			for(let i=0; i<randArr.length; i++) {
				$('.js-otherArticles-item').eq(randArr[i]).addClass(a);
			}

			// 3件以上ない場合はリンク非表示
			if($('.js-otherArticles-item').length < 3) {
				$('.js-otherArticles-link').remove();
			}
		}
	};
	// <おいしさの提案詳細ページ>関連レシピ
	const relatedRecipes = () => {
		if($('.js-relatedRecipes-wrap').length) {
			// 0件の場合
			if($('.js-relatedRecipes-item').length === 0) {
				$('.js-relatedRecipes-wrap').addClass('di_none');
			}
			// 非表示設定のものを削除
			$('.js-relatedRecipes-item').each((idx,ele) => {
				let thisStatus = $(ele).find('.rt_cf_r_status').text();
				if(thisStatus === '0') {
					$(ele).remove();
				} else {
					$(ele).addClass(v);
				}
			});
			// 最大4件まで表示
			$('.js-relatedRecipes-item.is-visible:nth-child(n+5)').remove();
		}
	};
	// <おいしさの提案詳細ページ>おすすめ関連商品
	const relatedProducts = () => {
		if($('.js-recommendProducts').length) {
			// 最大4件まで表示
			$('.js-recommendProducts:nth-child(n+5)').remove();

			// 非表示シリーズを削除
			$('.js-recommendProducts').each((idx,ele) => {
				if(!$(ele).find('a').length) {
					$(ele).remove();
					// 0件の場合
					if(!$('.js-recommendProducts').length) {
						$('.js-recommendProducts-wrap').remove();
					}
				}
			});
		} else {
			// 0件の場合
			$('.js-recommendProducts-wrap').remove();
		}
	};

	// ==============================================================================
	// おいしさの提案
	if(location.pathname.indexOf('/detail/') !== -1) {
		relatedRecipes();
		relatedProducts()
		recipeDetailSlider();
		otherArticles();
	};

})(window.jQuery, window.RIKEN);
